import { tv } from 'tailwind-variants'

export const toastViewportVariants = tv({
  base: 'fixed left-1/2 transform -translate-x-1/2 z-[9999] flex flex-col gap-1 pointer-events-none w-full max-w-[500px] px-3 md:px-0',
  variants: {
    isLobby: {
      true: 'top-[72px] md:top-12',
      false: 'top-[64px] md:top-2'
    }
  },
  defaultVariants: {
    isLobby: false
  }
})
